import { motion } from "motion/react";

// Slow-drifting colour orbs behind the glass. They are what backdrop-filter
// blurs, so the glass reads as glass rather than as a grey box.
const drift = (dx: number, dy: number, dur: number) => ({
  animate: { x: [0, dx, 0], y: [0, dy, 0] },
  transition: { duration: dur, repeat: Infinity, ease: "easeInOut" as const },
});

export function Backdrop() {
  return (
    <div className="backdrop" aria-hidden>
      <motion.div className="orb orb-a" {...drift(40, 30, 18)} />
      <motion.div className="orb orb-b" {...drift(-30, 40, 22)} />
      <motion.div className="orb orb-c" {...drift(30, -30, 26)} />
    </div>
  );
}
